import axios from 'axios'
import { servers } from '@/helpers'
import store from '@/store'

export const getAssets = async (data) => {
  var queryParams = ''
  if (data && data.type && data.values) {
    queryParams = `?${data['type']}=${data['values']}`
  }

  const response = await axios.get(`${servers[store.state.auth.server].asset_manager}/api/v1/assets${queryParams}`)

  return { assets: response.data.assets }
}

export const getImportableAssets = async (data) => {
  var queryParams = ''

  if (data && data.type && data.values) {
    queryParams = `?${data['type']}=${data['values']}`
  }

  const response = await axios.get(`${servers[store.state.auth.server].asset_manager}/api/v1/assets/import${queryParams}`)
  return response
}

export const importAsset = async (ids) => {
  const response = await axios.post(`${servers[store.state.auth.server].asset_manager}/api/v1/assets/import`, { ids: ids })
  return response
}

export const uploadAsset = async (data) => {
  let headers = {
    'X-Metadata': JSON.stringify({ 'filename': data['file']['filename'], 'is_staged': data['file']['is_staged'], 'is_secure': data['file']['is_secure'], 'tags': data['tags'] }),
    'Content-Type': data['file']['mime_type']
  }

  let response = await axios.post(`${servers[store.state.auth.server].asset_manager}/api/v1/assets`, data['file']['data'], { 'headers': headers })
  return response
}

export const updateAsset = async (data) => {
  let response = await axios.put(`${servers[store.state.auth.server].asset_manager}/api/v1/assets/${data['sha']}`, data['assetHeaders'])
  return response
}

export const createSchema = async () => {
  let response = await axios.post(`${servers[store.state.auth.server].asset_manager}/api/v1/schema`)
  return response
}

export default {
  getAssets,
  getImportableAssets,
  importAsset,
  uploadAsset,
  updateAsset,
  createSchema
}
